import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Link from 'next/link';
import i18n from 'src/utils/translate';
import styled from 'styled-components';
import config from 'config/config';
import { getCurrentRoute } from 'src/utils/router';

import { fetchNotifications } from 'src/modules/shared/context/actions';
import { showSignupModal, showLoginModal } from 'src/modules/shared/modal/actions';
import Badge from 'src/components/badges/badge';

// Sitebar subcomponents
import VisitorSiteBar from './visitorSiteBar';
import SearchBar from './searchBar';
import UserMenu from './userMenu'; // logged in, desktop
import HubMenu from './hubMenu'; // logged in, desktop
import NotificationMenu from './notificationMenu'; // logged in, desktop
import MobileSiteBar from './mobileSiteBar'; // logged in, mobile
import { footfall, footfallExternal } from './sitebarFootfall';
import { Section } from 'src/constants/footfall';

const SpeechBubbleLogo = styled.img`
  width: 32px;
  height: 32px;
  margin-left: -5px;
`;

const initialMenuState = {
  openUserMenu: false,
  openHubMenu: false,
  openNotifications: false,
};

class SiteBar extends Component {
  static propTypes = {
    basic: PropTypes.bool,
    currentUser: PropTypes.object,
  }

  static defaultProps = {
    basic: false,
    currentUser: {},
    fetchNotifications: () => {},
  }

  menuWrapperRef: any;

  state = { ...initialMenuState }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setMenuWrapperRef = (node) => {
    this.menuWrapperRef = node;
  }

  handleClickOutside = (event) => {
    if (this.menuWrapperRef && !this.menuWrapperRef.contains(event.target)) {
      this.setState(initialMenuState);
    }
  }

  toggleMenuHideOthers = (event, menuToToggle) => {
    if (event) event.preventDefault();
    const stateObj = { ...initialMenuState };
    if (menuToToggle) stateObj[menuToToggle] = !this.state[menuToToggle];
    this.setState(stateObj);
    if (event) event.stopPropagation();
  }

  onNotificationsClick = (event) => {
    if (!this.state.openNotifications) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'fetchNotifications' does not exist on ty... Remove this comment to see the full error message
      this.props.fetchNotifications();
    }
    this.toggleMenuHideOthers(event, 'openNotifications');
  }

  renderMemberSitebar() {
    const {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'unreadNotificationsCount' does not exist... Remove this comment to see the full error message
      unreadNotificationsCount,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'unreadMessagesCount' does not exist on t... Remove this comment to see the full error message
      unreadMessagesCount,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentUser' does not exist on type 'Rea... Remove this comment to see the full error message
      currentUser: user,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'notifications' does not exist on type 'R... Remove this comment to see the full error message
      notifications,
    } = this.props;
    const followedCommunities = user.followedCommunities;
    const homeClass = getCurrentRoute() === ('/home/explore' || '/home/newsfeed') ? 'sitebar__link sitebar__link--active' : 'sitebar__link';

    return (
      <nav aria-label="main navigation">
        <MobileSiteBar
          currentUser={user}
          unreadMessages={unreadMessagesCount}
          unreadNotifications={unreadNotificationsCount}
        />
        <div className="sitebar">
          <div className="sitebar-container hidden-xs" ref={this.setMenuWrapperRef}>
            <div className="sitebar-actions-left">
              <Link as="/newsfeed" href="/home/newsfeed">
                <a className={homeClass} onClick={() => footfall(Section.Home)}>
                  <SpeechBubbleLogo alt="HealthUnlocked small logo" src={`${config.cdn.static}img/logos/H-logo-speech-bubble-green.svg`} />
                  {i18n.t('My feed')}
                </a>
              </Link>

              <HubMenu
                // @ts-expect-error ts-migrate(2322) FIXME: Type '{ followedCommunities: any; handleClick: (e:... Remove this comment to see the full error message
                followedCommunities={followedCommunities}
                handleClick={(e) => {
                  footfall(Section.MyHub);
                  this.toggleMenuHideOthers(e, 'openHubMenu');
                }}
                open={this.state.openHubMenu}
                userId={user.userId}
              />

              <a
                className="sitebar__link"
                href="/messages"
                onClick={(e) => footfallExternal(e, '/messages', Section.Chat)}
              >
                <span className="icon-paper-plane" />
                {i18n.t('Chat')}
                {unreadMessagesCount > 0 && <Badge content={unreadMessagesCount} type="new" />}
              </a>

              <NotificationMenu
                handleClick={(e) => {
                  footfall(Section.Alerts);
                  this.onNotificationsClick(e);
                }}
                notifications={notifications}
                open={this.state.openNotifications}
                unreadNotifications={unreadNotificationsCount}
              />
            </div>

            <div className="site-logo">
              <a href="/" onClick={(e) => footfallExternal(e, '/', Section.HULogo)}>
                <img
                  alt="HealthUnlocked logo"
                  height="54"
                  src={`${config.cdn.static}img/logos/healthunlocked-logo.svg`}
                  width="214"
                />
              </a>
            </div>

            <div className="sitebar-actions-right">
              <SearchBar
                className="search-bar--navbar search-bar--navbar-member"
                // @ts-expect-error ts-migrate(2322) FIXME: Type '{ className: string; customId: string; onCli... Remove this comment to see the full error message
                customId="-sitebar"
                onClick={() => footfall(Section.Search)}
              />

              <UserMenu
                handleClick={e => {
                  footfall(Section.More);
                  this.toggleMenuHideOthers(e, 'openUserMenu');
                }}
                open={this.state.openUserMenu}
              />
            </div>
          </div>
        </div>
      </nav>
    );
  }

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isLoggedIn' does not exist on type 'Read... Remove this comment to see the full error message
    if (this.props.isLoggedIn) {
      return this.renderMemberSitebar();
    } else {
      return <VisitorSiteBar />;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    isLoggedIn: !!state.context.currentUser,
    currentUser: state.context.currentUser,
    unreadNotificationsCount: state.context.unreadNotificationsCount,
    unreadMessagesCount: state.context.unreadMessagesCount,
    notifications: state.context.notifications,
  };
};

// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof SiteBar' is not assignabl... Remove this comment to see the full error message
export default connect(mapStateToProps, { fetchNotifications, showLoginModal, showSignupModal })(SiteBar);
